export { default as Icon } from "./icon";
export type { IconProps, StandardProps, MonochromeProps } from "./icon";
